import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { Anchor, Box, Flex, Inline, Text, xcss } from '@atlaskit/primitives';
import type { UIEventPayload } from '@atlassiansox/analytics-web-client';

import { useRovoDevWebAnalyticsClient } from '../../../controllers/rovo-dev-web-analytics-events';

type SmartCardProps = {
	bitbucketRedirectUrl: string;
	workspaceName: string;
	analyticEvent?: UIEventPayload;
};

const SmartCard = ({ bitbucketRedirectUrl, workspaceName, analyticEvent }: SmartCardProps) => {
	const { fireUiEvent } = useRovoDevWebAnalyticsClient();
	return (
		<Anchor
			interactionName="link"
			href={bitbucketRedirectUrl}
			xcss={anchorStyles}
			target="_blank"
			onClick={() => {
				if (analyticEvent) {
					fireUiEvent(analyticEvent);
				}
			}}
		>
			<Box xcss={smartCardStyles}>
				<Box xcss={boxStyles}>
					<Flex gap="space.100" alignItems="center" justifyContent="space-between">
						<Inline space="space.100" alignBlock="center">
							<Box xcss={workspaceTextStyles}>
								<Text weight="regular" size="medium" color="color.link">
									{workspaceName}
								</Text>
							</Box>
						</Inline>
						<LinkExternalIcon label="Workspace Setting" />
					</Flex>
				</Box>
			</Box>
		</Anchor>
	);
};

const boxStyles = xcss({
	backgroundColor: 'elevation.surface.raised',
	borderRadius: '6px',
	border: '1px solid #E3E4F21F',
	borderColor: 'color.border',
	paddingTop: 'space.100',
	paddingRight: 'space.150',
	paddingBottom: 'space.100',
	paddingLeft: 'space.150',
	gap: 'space.050',
	':hover': {
		backgroundColor: 'elevation.surface.raised.hovered',
	},
});

const workspaceTextStyles = xcss({
	font: 'font.body',
	fontWeight: 'font.weight.regular',
	color: 'color.link',
});

const anchorStyles = xcss({
	textDecoration: 'none',
	color: 'color.text',
	':hover': {
		textDecoration: 'none',
	},
});

const smartCardStyles = xcss({
	paddingTop: 'space.100',
	paddingBottom: 'space.100',
	gap: 'space.050',
});

export default SmartCard;
